module.exports = __webpack_public_path__ + "img/唐龙视界logo_画板 1.8eb8b470.svg";